import { configureStore, Middleware } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import appReducer from "./appSlice";
import authReducer from "./authSlice";
import dreamReducer from "./dreamSlice";
import dashboardReducer from "./dashboardSlice";
import settingsReducer from "./settingsSlice";
import profileReducer from "./profileSlice";
import privacyReducer from "./privacySlice";
import billingReducer from "./billingSlice";

const isDevelopment = process.env.NODE_ENV === "development";
const logger = createLogger({
  actionTransformer: (action) => action.type === "auth/setAccessToken" ? { ...action, payload: "[REDACTED]" } : action,
  stateTransformer: (state) => ({ ...state, auth: { ...state.auth, accessToken: state.auth?.accessToken ? "[REDACTED]" : null } }),
});

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    dream: dreamReducer,
    dashboard: dashboardReducer,
    settings: settingsReducer,
    profile: profileReducer,
    privacy: privacyReducer,
    billing: billingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    isDevelopment
      ? getDefaultMiddleware().concat(logger as Middleware)
      : getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
